// extracted by mini-css-extract-plugin
module.exports = {"loadGame":"StatisticsElement_loadGame__1zB9V","loadGame_body":"StatisticsElement_loadGame_body__3gTSy"};